import React, { useEffect, useState } from 'react';
import MomentUtils from '@date-io/moment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import StoresDialog from './StoresDialog';
import { connect } from 'react-redux';
import {
  getPointOfSales,
  getPartners,
  getRegions,
  updatePointOfSale,
  addPointOfSale,
  updateOpeningHours,
  syncFlipdishMenu,
  subscribeToMessaging,
  updateMerchant
} from '../../../actions/adminActions';

import { Box, Skeleton, Tooltip } from '@mui/material';
import { OpeningHour } from '@m4a3/api-client/dist/models/shared/opening-hours.interface';
import { AvailabilityMode, PointOfSale } from '@m4a3/api-client';
import AvailabilityMenu from '../../../components/AvailabilityMenu/AvailabilityMenu';
import { useDispatch } from 'react-redux';
import { orderfulApi } from '../../../services/api-instances';

const StoresLoading = (): JSX.Element => {
  return (<TableRow>
      <TableCell component="th" scope="row" style={{ padding: 10 }}>
        <Skeleton width={'50%'} height={20} />
      </TableCell>
      <TableCell component="th" scope="row" style={{ padding: 10 }}>
        <Skeleton width={'100%'} height={20} />
      </TableCell>
      <TableCell style={{ padding: 10 }}>
        <Skeleton width={'100%'} height={20} />
      </TableCell>
      <TableCell align="right" style={{ padding: 10 }}>
        <Skeleton width={'30%'} height={20} style={{ float: 'right' }} />
      </TableCell>
      <TableCell align="right" style={{ padding: 10 }}>
        <Skeleton width={'30%'} height={20} style={{ float: 'right' }} />
      </TableCell>
      <TableCell align="right" style={{ padding: 10 }}>
        <Skeleton width={'30%'} height={20} style={{ float: 'right' }} />
      </TableCell>
      <TableCell align="right" style={{ padding: 10 }}>
        <Skeleton width={'30%'} height={20} style={{ float: 'right' }} />
      </TableCell>
    </TableRow>);
};

function StoresTable({
  pointOfSales,
  fetchingPointOfSales,
  partners,
  fetchingPartners,
  updateOpeningHours,
  cellId,
  getPointofSales,
  getPartners,
  updatePointOfSale,
  addPointOfSale,
  notify,
  syncFlipdishMenu
}) {
  const [openAddStoreDialog, setOpenAddStoreDialog] = useState(false);
  const [openEditStoreDialog, setOpenEditStoreDialog] = useState(false);
  const [storeToEdit, setStoreToEdit] = useState<any>();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(subscribeToMessaging());
    getPointofSales(cellId);
    getPartners();
  }, [cellId, getPointofSales, getPartners]);

  const handleCloseStoreDialog = () => {
    setOpenAddStoreDialog(false);
  };

  const handleOpenStoreDialog = () => {
    setOpenAddStoreDialog(true);
  };

  const handleCloseEditStoreDialog = () => {
    setOpenEditStoreDialog(false);
  };

  const handleSaveNewStore = (store: PointOfSale) => {
    addPointOfSale(store);
  };

  const handleEditStore = (store: PointOfSale) => {
    updateMerchant(store);
    updatePointOfSale(store);
  };

  const updateHours = (hours, posId) => {
    const formattedHours = hours.openingHoursForWeek.map(openingHour => {
      let startTime = openingHour.startTime;
      let endTime = openingHour.endTime;
      if (new MomentUtils().moment.isMoment(openingHour.startTime)) {
        startTime = new MomentUtils().moment(openingHour.startTime, 'HH:mm:ss').format('HH:mm:ss')
      }
      if (new MomentUtils().moment.isMoment(openingHour.endTime)) {
        endTime = new MomentUtils().moment(openingHour.endTime, 'HH:mm:ss').format('HH:mm:ss')
      }
      return Object.assign({}, openingHour, {
        startTime,
        endTime
      });
    });

    updateOpeningHours(formattedHours);
  };

  const updatePointOfSaleAvailabilityMode = (newMode: AvailabilityMode, pointOfSale: PointOfSale) => {
    const updatedPos: PointOfSale = {
      ...pointOfSale,
      availabilityMode: newMode
    };
    updatePointOfSale(updatedPos);
  }

  const handleRetrieveUpdatedStoreContent = async (merchant) => {
    const merchantToEdit =  await orderfulApi.getMerchantById(merchant.cellId, merchant.id);
    setOpenEditStoreDialog(true);
    setStoreToEdit(merchantToEdit);
  }

  return (
    <div>
      <div>
        <TableContainer component={Paper}>
          <Grid container style={{ padding: 15 }}>
            <Grid>
              <h3 style={{ fontSize: 20, fontFamily: 'Arial', marginTop: 10 }}>
                Stores
              </h3>
            </Grid>
            <Grid>
              <Button
                style={{
                  float: 'right',
                  marginLeft: 12,
                  top: 5,
                }}
                variant="contained"
                size='small'
                color="primary"
                onClick={handleOpenStoreDialog}>
                Add Store
              </Button>
            </Grid>
          </Grid>
          <Table
            style={{
              minWidth: 650
            }}
            size="small">
            <TableHead>
              <TableRow>
                <TableCell size="small">Logo</TableCell>
                <TableCell size="small">Availability</TableCell>
                <TableCell size="small" align="right"></TableCell>
                <TableCell size="small" align="right"></TableCell>
                <TableCell size="small">Name</TableCell>
                <TableCell size="small">App ID</TableCell>
                <TableCell size="small">Position</TableCell>
                <TableCell size="small">In-house</TableCell>
                <TableCell size="small">Display</TableCell>
                <TableCell size="small">Open</TableCell>
                <TableCell size="small">Pre-avail</TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ overflow: 'scroll' }}>
              {fetchingPointOfSales && (
                <>
                  <StoresLoading />
                  <StoresLoading />
                  <StoresLoading />
                  <StoresLoading />
                  <StoresLoading />
                  <StoresLoading />
                  <StoresLoading />
                  <StoresLoading />
                  <StoresLoading />
                  <StoresLoading />
                  <StoresLoading />
                </>
              )}
              {!fetchingPointOfSales &&
                pointOfSales &&
                Array.isArray(pointOfSales) &&
                pointOfSales
                  .sort((a, b) => a.sortOrder - b.sortOrder)
                  .map(pointOfSale => {
                    return (
                      <TableRow key={pointOfSale.fdAppId}>
                        <TableCell size="small" component="th" scope="row">
                          <img
                            alt={pointOfSale.name}
                            src={pointOfSale.logo}
                            style={{ height: 50, width: 50 }}></img>
                        </TableCell>
                        <TableCell size="small" align="right">
                          <AvailabilityMenu
                            availabilityMode={pointOfSale.availabilityMode}
                            onChangeAvailabilityMode={(newMode: AvailabilityMode) => updatePointOfSaleAvailabilityMode(newMode, pointOfSale)}
                            allowPause={true} />
                        </TableCell>
                        <TableCell size="small" align="right">
                          <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            onClick={() => {
                              syncFlipdishMenu(pointOfSale.id);
                            }}
                            style={{ marginLeft: 10 }}>
                            Sync with Flipdish
                          </Button>
                        </TableCell>
                        <TableCell size="small" align="right">
                          <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            onClick={() => {
                              handleRetrieveUpdatedStoreContent(pointOfSale);
                            }}
                            style={{ marginLeft: 10 }}>
                            Edit
                          </Button>
                        </TableCell>
                        <TableCell size="small">{pointOfSale.posName}</TableCell>
                        <TableCell size="small">fd{pointOfSale.fdAppId}</TableCell>
                        <TableCell size="small">{pointOfSale.sortOrder}</TableCell>
                        <TableCell size="small">
                          <Tooltip title="A merchant is in-house if it doesn't require a collector, e.g. Heavenly Cafe." arrow>
                            <span style={{ cursor: 'help' }}>{pointOfSale.isInHouse ? 'Yes ✅' : 'No ❌'}</span>
                          </Tooltip>
                        </TableCell>
                        <TableCell size="small">
                          <Box
                            sx={{
                              backgroundColor: pointOfSale.displayStore
                                ? 'green'
                                : 'red',
                              height: 24,
                              width: 24,
                              borderRadius: 24
                            }}
                          />
                        </TableCell>
                        <TableCell size="small">
                          <Box
                            sx={{
                              backgroundColor: pointOfSale.open ? 'green' : 'red',
                              height: 24,
                              width: 24,
                              borderRadius: 24
                            }}
                          />
                        </TableCell>
                        <TableCell size="small">
                          <Box
                            sx={{
                              backgroundColor: pointOfSale.preorderAvail
                                ? 'green'
                                : 'red',
                              height: 24,
                              width: 24,
                              borderRadius: 24
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <StoresDialog
        edit={false}
        modalOpen={openAddStoreDialog}
        partners={partners}
        cellId={cellId}
        onClose={handleCloseStoreDialog}
        onSave={handleSaveNewStore}
        notify={notify}
        updateOpeningHours={updateHours}
      />
      <StoresDialog
        edit={true}
        store={storeToEdit}
        cellId={cellId}
        partners={partners}
        modalOpen={openEditStoreDialog}
        onClose={handleCloseEditStoreDialog}
        onEdit={handleEditStore}
        notify={notify}
        updateOpeningHours={updateHours}
      />
    </div>
  );
}

const mapStateToProps = state => {
  return {
    pointOfSales: state.admin.pointOfSales,
    fetchingPointOfSales: state.admin.fetchingPointOfSales,
    regions: state.admin.regions,
    fetchingRegions: state.admin.fetchingRegions,
    partners: state.admin.partners,
    fetchingPartners: state.admin.fetchingPartners,
    cellId: state.orders.selectedCellId
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getPointofSales: (cellId: number) => dispatch(getPointOfSales(cellId)),
    getPartners: () => dispatch(getPartners()),
    getRegions: () => dispatch(getRegions()),
    updatePointOfSale: (store: PointOfSale) => dispatch(updatePointOfSale(store)),
    addPointOfSale: (store: PointOfSale) => dispatch(addPointOfSale(store)),
    updateOpeningHours: (openingHours: OpeningHour[]) =>
      dispatch(updateOpeningHours(openingHours)),
    syncFlipdishMenu: (posId: number) => dispatch(syncFlipdishMenu(posId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StoresTable);
